<template>
  <div>
    <div>{{ getMessage }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DepositoryMessage',
  computed: {
    ...mapGetters('depository', [
      'getIsAuthorized',
      'getCurrentCountDownload',
      'getMaxCountDownload'
    ]),
    getMessage: function () {
      let text = ''
      if (!this.getIsAuthorized) {
        text = 'Авторизируйтесь для загрузки файлов'
      } else {
        text = `Доступное кол-во файлов для загрузки: ${this.getMaxCountDownload - this.getCurrentCountDownload}`
      }
      return text
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/DepositoryMessage.vue